import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAutorizados, obtenerObras, registrarSalida } from "../redux/actions/index";
import { useNavigate } from "react-router-dom";
import SweetAlert from "sweetalert2";
import axios from "axios";

const Carrito = ({ carrito, setCarrito, clienteId, usuarioId }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state);
  const autorizadosCliente = useSelector((state) => state.autorizadosCliente);
  const [autorizadoId, setAutorizadoId] = useState("");
  const [obraSeleccionada, setObraSeleccionada] = useState("");
  const navigate = useNavigate();
  const obras = useSelector((state) => state.obras);

  const eliminarProducto = (id) => {
    setCarrito(carrito.filter((producto) => producto.id !== id));
  };

  useEffect(() => {
    dispatch(fetchAutorizados(clienteId));
    dispatch(obtenerObras());
  }, [dispatch, clienteId]);

  const handleRegistrarSalida = async () => {
    const productosParaRegistrar = carrito.map(({ id, cantidad }) => ({
      productoId: id,
      cantidad,
    }));

    try {
      await dispatch(
        registrarSalida({
          clienteId,
          usuarioId,
          productos: productosParaRegistrar,
          IdObra: obraSeleccionada,
          autorizadoId: autorizadoId,
        })
      );

      // Generar y descargar el remito PDF
      const respuesta = await axios.post(
        "/api/remito",
        {
          id: `S-${Date.now()}`,
          productos: carrito,
          clienteId: clienteId,
          autorizadoId: autorizadoId,
          comentario: "Comentario de salida",
          usuarioId: usuarioId,
          obraId: obraSeleccionada,
        },
        { responseType: "blob" } // Esto asegura que obtenemos el archivo como blob
      );

      // Crear una URL del archivo blob
      const blob = new Blob([respuesta.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // Abrir el PDF en una nueva ventana para imprimir o guardar
      window.open(url, "_blank");

      SweetAlert.fire(
        "Éxito",
        "La salida de productos y el remito se generaron correctamente.",
        "success"
      );

      setCarrito([]);
      navigate("/inicio");
    } catch (error) {
      console.error("Error al registrar la salida:", error);
      SweetAlert.fire(
        "Error",
        "No se pudo registrar la salida de productos o generar el remito.",
        "error"
      );
    }
  };

  useEffect(() => {
    dispatch(obtenerObras()); // Cargar las obras al montar el componente
  }, [dispatch]);

  return (
    <div className="w-full">
      <h1 className="flex text-white justify-center text-4xl font-bold">
        Carrito
      </h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <section className="text-gray-600 body-font">
        <div className="container px-5 py-8 mx-auto">
          <div className="flex justify-between -mx-4 -mb-10 text-center">
            <div className="mx-auto flex w-full flex-col justify-center px-5 pt-0 md:h-[unset] md:max-w-[95%] mt-10">
              <div className="h-full w-full rounded-lg ">
                <div className="rounded-lg border bg-card text-card-foreground shadow-sm h-full w-full border-zinc-200 p-0 dark:border-zinc-800 sm:overflow-auto">
                  <div className="overflow-x-scroll xl:overflow-x-hidden">
                    <div className="relative w-full overflow-auto">
                      <table>
                        <thead className="border-b-2 border-zinc-200 p-6 dark:border-zinc-800">
                          <tr className="dark:border-zinc-800">
                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            >
                              <p className="text-xs font-semibold text-textoClaro">
                                Nombre Producto
                              </p>
                            </th>

                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            >
                              <p className="text-xs font-semibold text-textoClaro">
                                Categoria
                              </p>
                            </th>
                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            >
                              <p className="text-xs font-semibold text-textoClaro">
                                Cantidad
                              </p>
                            </th>
                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            >
                              <p className="text-xs font-semibold text-textoClaro">
                                Stock Actual
                              </p>
                            </th>
                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            >
                              <p className="text-xs font-semibold text-textoClaro">
                              Unidad
                              </p>
                            </th>
                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            ></th>
                          </tr>
                        </thead>
                        <tbody className="">
                          {carrito.map((producto) => (
                            <tr className="border-b-2 border-zinc-800 transition-colors hover:bg-muted/50  px-6 dark:hover:bg-gray-900">
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-800 py-5 pl-5 pr-4">
                                <p className="text-sm font-medium text-textoClaro">
                                  {producto?.nombre}
                                </p>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-800 py-5 pl-5 pr-4">
                                <div className="flex w-full items-center gap-[14px]">
                                  <p className="text-sm font-medium text-textoClaro">
                                    {producto?.categoria?.nombre}
                                  </p>
                                </div>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-800 py-5 pl-5 pr-4">
                                <div className="flex w-full items-center gap-[14px]">
                                  <p className="text-sm font-medium text-textoClaro">
                                    {producto.cantidad}
                                  </p>
                                </div>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-800 py-5 pl-5 pr-4">
                                <div className="flex w-full items-center gap-[14px]">
                                  <p className="text-sm font-medium text-textoClaro">
                                    {producto?.stock}
                                  </p>
                                </div>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-800 py-5 pl-5 pr-4">
                                <div className="flex w-full items-center gap-[14px]">
                                  <p className="text-sm font-medium text-white">
                                    {producto?.unidadMedida}
                                  </p>
                                </div>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-00 py-5 pl-5 pr-4">
                                <button
                                  className="inline-flex mt-3 ml-3 px-2 py-1 rounded-lg z-10 bg-red-500 text-sm font-medium text-white select-none"
                                  onClick={() => eliminarProducto(producto.id)}
                                >
                                  Eliminar
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="mt-4 flex items-center">
          
      <label className="block text-white">Autorizado:</label>
      <select
        value={autorizadoId}
        onChange={(e) => setAutorizadoId(e.target.value)}
        className="w-full p-2 rounded"
      >
        <option value="">Seleccionar autorizado</option>
        {autorizadosCliente.map((autorizado) => (
          <option key={autorizado.id} value={autorizado.id}>
            {autorizado.nombre}
          </option>
        ))}
      </select>
                  <label className="text-white mr-4">Obra</label>
                  <select
                    value={obraSeleccionada}
                    onChange={(e) => setObraSeleccionada(e.target.value)}
                    className="px-4 py-2 rounded bg-white text-black"
                  >
                    <option value="" disabled>
                      Selecciona una obra
                    </option>
                    {obras?.map((obra) => (
                      <option key={obra.id} value={obra.id}>
                        {obra.nombre}
                      </option>
                    ))}
                  </select>
                  <button
                    className="bg-green-500 text-white px-4 py-2 mt-2 rounded ml-4"
                    onClick={handleRegistrarSalida}
                    disabled={carrito.length === 0}
                  >
                    {loading ? "Registrando..." : "Registrar Salida"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Carrito;
